import { type RefObject, useEffect, useRef } from 'react';
import { NOW_LINE_OFFSET } from '../../constants';

type UseScrollToNowLineProperties = {
  bodyReference: RefObject<HTMLDivElement | null>;
  enabled: boolean;
  top: number;
};

export const useScrollToNowLine = ({ bodyReference, enabled, top }: UseScrollToNowLineProperties) => {
  const hasScrolledToNowLine = useRef(false);

  useEffect(() => {
    if (!enabled) {
      hasScrolledToNowLine.current = false;
      return;
    }

    if (!bodyReference.current || hasScrolledToNowLine.current || top <= 0) {
      return;
    }

    const nextScrollTop = Math.max(0, top - NOW_LINE_OFFSET);

    const animationFrameId = requestAnimationFrame(() => {
      const currentElement = bodyReference.current;

      if (!currentElement) {
        return;
      }

      currentElement.scrollTo({ behavior: 'smooth', top: nextScrollTop });
      hasScrolledToNowLine.current = true;
    });

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [bodyReference, enabled, top]);
};
